const locale = {
    placeholder: 'Επιλέξτε ώρα',
};
export default locale;
